class Logout {
  /**
   * Constructor
   *
   * @param {Element} el Element with the class `.wsum-logout`
   */
  constructor(el) {
    this.button = el
    this.endpoint = `${window.sapiens.api}/auth/logout`
    this.doLogout = this.doLogout.bind(this)

    this.init()
  }

  /**
   * Logout Action
   *
   * Clear cookies and session storage.
   * Logout the current user
   *
   * @param {Event} e Click Event
   */
  doLogout(e) {
    e.preventDefault()
    window.sessionStorage.clear()
    window.location.href = this.endpoint
  }

  init() {
    this.button.addEventListener('click', this.doLogout)
  }

  destroy() {
    this.button.removeEventListener('click', this.doLogout)
  }
}

const logoutInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.customer-logout')
    wrapperEl.forEach(form => new Logout(form))
  },
}

export default logoutInit
